var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBracketsAngle = function SvgIconBracketsAngle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.344 4.287a1 1 0 1 0-1.688-1.074l-5.25 8.25a1 1 0 0 0 0 1.074l5.25 8.25a1 1 0 1 0 1.688-1.074L3.435 12zM17.344 3.213a1 1 0 0 0-1.688 1.074L20.565 12l-4.909 7.713a1 1 0 0 0 1.688 1.074l5.25-8.25a1 1 0 0 0 0-1.074z"
  }))));
};
export default SvgIconBracketsAngle;